import * as Yup from 'yup';

export const array = Yup.array();
export const boolean = Yup.boolean();
export const date = Yup.date();
export const mixed = Yup.mixed();
export const number = Yup.number();
export const object = Yup.object();
export const string = Yup.string();
